export default __webpack_public_path__ + "static/media/welcome.ea90255f.svg";